import * as types from './types'
import http from '@/Plugins/api'

export default {
  setWallMessage({ commit }, data) {
    commit(types.SET_WALLMESSAGE, data)
    // Set IsRead flag
  },
  setWallMessageData({ commit }, data) {
    commit(types.SET_WALLMESSAGE_DATA, data)
  },
  resetWallMessages({ commit }) {
    commit(types.RESET_WALLMESSAGES)
  },
  resetWallMessage({ commit }, data) {
    commit(types.RESET_WALLMESSAGE, data)
  },
  setWorkingText({ commit }, text) {
    commit(types.SET_WORKINGTEXT, text)
  },
  async getMergeTags({ commit }) {
    const r = await http.get('v2/settings/mergeTags')
    commit(types.SET_MERGETAGS, r.data.data)
    return r.data.data
  },
  async getWallMessages({ commit, state }, data) {
    let url = 'v2/coachingwall'
    if (data.reset) {
      commit(types.RESET_WALLMESSAGES)
    }
    if (state.cursorUrl) {
      url = `v2/coachingwall?cursor=${state.cursorUrl}`
    }
    const r = await http.get(url, {
      params: data,
    })
    commit(types.SET_WALLMESSAGES, r.data.data)
    return r.data.data
  },
  async getWallMessage({ commit }, id) {
    const r = await http.get(`v2/coachingwall/edit/${id}`)
    commit(types.SET_WALLMESSAGE, r.data.data)
    return r.data.data
  },
  async saveWallMessage({ commit }, data) {
    let r = null
    r = await http.post('v2/coachingwall', data)
    return r.data.data
  },
  async removeWallMessage({ commit }, id) {
    const r = await http.delete(`v2/coachingwall/${id}`)
    return r.data.data
  },
  async setReadMessage({ commit }, data) {
    const r = await http.post(`v2/coachingwall/setread`, data)
    return r.data.data
  },
  async clearAllUnread({ commit }, data) {
    const r = await http.post(`v2/coachingwall/clearall`, data)
    commit(types.SET_ALLREAD, data)
    return r.data.data
  },
  async getNewMessageCount({ commit }, data) {
    const r = await http.get(`v2/coachingwall/newmessagecount?id=${data.id}`)
    commit(types.SET_READCOUNT, { data: data, count: r.data })
  },
}
